import { useMutation } from '@apollo/client';
import { Breadcrumbs } from 'components/Breadcrumbs/Breadcrumbs';
import { Button } from 'components/Button/Button';
import { EmptyState } from 'components/EmptyState/EmptyState';
import { Icon } from 'components/Icon/Icon';
import { MemberTabs } from 'components/MemberTabs/MemberTabs';
import { toast } from 'components/Toast/use-toast';
import { UserPreferencesPreview } from 'components/UserPreferencesPreview/UserPreferencesPreview';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { AppRoutes } from 'Routes';
import { PARTNER_DELETE } from 'services/users/mutation';
import { useUserStore } from 'stores/user.store';

import { MemberHeader } from '../../components/MemberHeader/MemberHeader';

import { PartnerImagePreview } from './_components/PartnerImagePreview/PartnerImagePreview';
import { PartnerInfoPreview } from './_components/PartnerInfoPreview/PartnerInfoPreview';
import { PartnerRemoveModal } from './_components/PartnerRemoveModal/PartnerRemoveModal';

export const MemberPartner = () => {
    const partner = useUserStore(state => state.user?.partner);
    const user = useUserStore(state => state.user);
    const getUser = useUserStore(state => state.getUser);
    const { id } = useParams();
    const navigate = useNavigate();
    const { t } = useTranslation('dashboard');
    const { t: p } = useTranslation('partner');
    const { t: b } = useTranslation('translation');
    const [removeModal, setRemoveModal] = useState(false);
    const [partnerDeleteMutation] = useMutation(PARTNER_DELETE);

    const editPartner = () => {
        if (!id) return;
        navigate(AppRoutes.memberEditPartner.replace(':id', id));
    };

    const removePartner = () => {
        setRemoveModal(false);
        handlePartnerRemove();
    };

    const handlePartnerRemove = () => {
        const userID = user?.id;
        const partnerID = partner?.id;
        partnerDeleteMutation({ variables: { partner: partnerID } }).then(r => {
            if (r.data.partnerRemove.success) {
                if (userID) getUser(userID);
                toast({
                    title: p('partnerRemoveSuccess'),
                    variant: 'success',
                });
            }
        });
    };

    return (
        <>
            <div id="partner">
                <Breadcrumbs
                    crumbs={[
                        b('breadcrumbs.dashboard'),
                        b('breadcrumbs.members'),
                        `${user?.firstName} ${user?.lastName}`,
                    ]}
                />
                <MemberHeader>
                    {partner && (
                        <div className="flex gap-2">
                            <Button onClick={() => setRemoveModal(true)} variant="outline">
                                <Icon name="trash" className="h-4 mr-2" /> {p('removeButton')}
                            </Button>
                            <Button onClick={() => editPartner()}>
                                <Icon name="edit" className="h-4 mr-2" /> {t('editButton')}
                            </Button>
                        </div>
                    )}
                </MemberHeader>
                <MemberTabs />
                {!partner && (
                    <EmptyState
                        image="/images/no-partner.png"
                        title={p('emptyState.title')}
                        text={p('emptyState.subtitle')}
                        button={p('emptyState.button')}
                        onClick={() => editPartner()}
                    />
                )}
                {partner && (
                    <div className="flex flex-col gap-6">
                        <div className="flex gap-6 pd-4">
                            <PartnerImagePreview image={partner?.image} />
                            <PartnerInfoPreview />
                        </div>
                        <UserPreferencesPreview user={partner} />
                    </div>
                )}
            </div>
            <PartnerRemoveModal isOpen={removeModal} onClose={() => setRemoveModal(false)} onConfirm={removePartner} />
        </>
    );
};
